import { render, staticRenderFns } from "./cover.vue?vue&type=template&id=d2a104ba&scoped=true&"
import script from "./cover.vue?vue&type=script&lang=js&"
export * from "./cover.vue?vue&type=script&lang=js&"
import style0 from "./cover.vue?vue&type=style&index=0&id=d2a104ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a104ba",
  null
  
)

export default component.exports